import { render } from "./Pie6Charts.vue?vue&type=template&id=22052f1f&scoped=true"
import script from "./Pie6Charts.vue?vue&type=script&lang=js"
export * from "./Pie6Charts.vue?vue&type=script&lang=js"

import "./Pie6Charts.vue?vue&type=style&index=0&id=22052f1f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22052f1f"]])

export default __exports__